import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="change-year"
export default class extends Controller {
  connect() {}

  change() {
    var groupFilter = document.getElementById("cat_group");
    console.log("change");

    if (groupFilter) {
      groupFilter.value = "";
    }

    Rails.fire(this.element.form, "submit");
  }
}
